module.exports = __webpack_public_path__ + "static/media/tec3.39a8728a.jpg";